import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { ROUTES } from 'shared/routes/constants';
import PaymentClaimUI from 'uicontainers/apps/survey/PaymentClaim';
import PaymentClaimRefresh from 'uicontainers/apps/survey_refresh/PaymentClaim';
import { useSurveyContent } from '../../../../shared/hooks';

export const PaymentClaim = () => {
  const { surveyContent } = useSurveyContent();
  return (
    <>
      <Switch>
        <Route
          path={ROUTES.SURVEY.PATHS.PAYMENT_CLAIM_BY_ID}
          component={
            surveyContent?.survey_template === 'SURVEY_2025' ? PaymentClaimRefresh : PaymentClaimUI
          }
        />
      </Switch>
    </>
  );
};

export default PaymentClaim;
